// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { ImageAspectRatio } from "../../../../components/image_aspect_ratio/ImageAspectRatio";

@Component({
  mixins: [template],
  components: {
    ImageAspectRatio,
  },
})
export default class KonsiSliderItem extends Vue {
  @Prop()
  public konsi!: any;

  @Prop()
  public translation!: object;

  public downloadDocument() {}

  public handleClick($event) {
    $event.preventDefault();
    this.$emit("click", this.konsi);
  }
}
